/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GameType } from './GameType';
import {
    GameTypeFromJSON,
    GameTypeFromJSONTyped,
    GameTypeToJSON,
} from './GameType';

/**
 * A promotional message scheduled against one game. At most one is live per game at any instant —
 * enforced by an exclusion constraint, not by application code.
 * @export
 * @interface GamePromotionalMessage
 */
export interface GamePromotionalMessage {
    /**
     * 
     * @type {Date}
     * @memberof GamePromotionalMessage
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GamePromotionalMessage
     */
    createdAt: Date;
    /**
     * Null means the message never ends.
     * @type {Date}
     * @memberof GamePromotionalMessage
     */
    activeTo?: Date | null;
    /**
     * Null means the message is already live.
     * @type {Date}
     * @memberof GamePromotionalMessage
     */
    activeFrom?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GamePromotionalMessage
     */
    message: string;
    /**
     * Derived from the game, never taken from the request.
     * @type {GameType}
     * @memberof GamePromotionalMessage
     */
    gameType: GameType;
    /**
     * GDS game UUID.
     * @type {string}
     * @memberof GamePromotionalMessage
     */
    gameId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof GamePromotionalMessage
     */
    customerId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof GamePromotionalMessage
     */
    id: string;
}



/**
 * Check if a given object implements the GamePromotionalMessage interface.
 */
export function instanceOfGamePromotionalMessage(value: object): value is GamePromotionalMessage {
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('gameType' in value) || value['gameType'] === undefined) return false;
    if (!('gameId' in value) || value['gameId'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GamePromotionalMessageFromJSON(json: any): GamePromotionalMessage {
    return GamePromotionalMessageFromJSONTyped(json, false);
}

export function GamePromotionalMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamePromotionalMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'updatedAt': (new Date(json['updatedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'activeTo': json['activeTo'] == null ? undefined : (new Date(json['activeTo'])),
        'activeFrom': json['activeFrom'] == null ? undefined : (new Date(json['activeFrom'])),
        'message': json['message'],
        'gameType': GameTypeFromJSON(json['gameType']),
        'gameId': json['gameId'],
        'customerId': json['customerId'],
        'id': json['id'],
    };
}

export function GamePromotionalMessageToJSON(value?: GamePromotionalMessage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'updatedAt': ((value['updatedAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'activeTo': value['activeTo'] == null ? undefined : ((value['activeTo'] as any).toISOString()),
        'activeFrom': value['activeFrom'] == null ? undefined : ((value['activeFrom'] as any).toISOString()),
        'message': value['message'],
        'gameType': GameTypeToJSON(value['gameType']),
        'gameId': value['gameId'],
        'customerId': value['customerId'],
        'id': value['id'],
    };
}

